module.exports = __webpack_public_path__ + "img/vikings-2.26e3e4a7.webp";